// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27pjW","option":"styles_option__3nEo2","selected":"styles_selected__23SlZ"};